import {defineMessages} from 'react-intl';

export default defineMessages({
	returnOrderTitle: {
		id: 'returnOrder.title',
		defaultMessage: 'Return Order',
	},
});
